<span class="fm-icon" v-html="iconCode"></span>